import { Box, Container, Stack } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { generatePath, useNavigate } from "../../../../router-utils"
import { useXHR } from "@sembark-travel/xhr"
import {
	NewCallerDeskIntegrationForm,
	type TIntegration,
} from "../../../../Integrations"

export default function NewCallerDeskIntegrationPage() {
	const xhr = useXHR()
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>New CallerDesk Integration</title>
			</Helmet>
			<Breadcrumbs
				title="New Integration"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					["", "CallerDesk Integration"],
				]}
			/>
			<Box paddingX="4" paddingY="8">
				<Box maxWidth="3xl" marginX="auto">
					<Box borderWidth="1" rounded="md" bgColor="default">
						<Container paddingY="6">
							<Stack gap="4">
								<NewCallerDeskIntegrationForm
									initialValues={{
										name: "CallerDesk",
										description: "Inbound calls via CallerDesk",
									}}
									onSubmit={async (values) => {
										const integration = await xhr
											.post<{ data: TIntegration }>("integrations", {
												...values,
												platform: "tc_callerdesk",
											})
											.then((resp) => resp.data.data)
										navigate("/integrations/:integrationId", {
											params: {
												integrationId: integration.uid,
											},
											replace: true,
										})
									}}
									onCancel={() => {
										navigate("/org/integrations", { replace: true })
									}}
								/>
							</Stack>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
